import React from "react";
import { Route, Navigate } from "react-router";
import { useAuth } from "../context/AuthContext";

export default function RestrictedRoute({ component: Component }) {
  const { currentUser } = useAuth();

  return currentUser ? <Navigate to="/dashboard" /> : <Component />;
}
